import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const StyledContainer = styled(Container)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(2)
}));

const LoadingPlaceholder = ({ height, children }) => {
    const { t } = useTranslation();

    return (
        <StyledContainer style={{ height: height ?? '100vh' }}>
            <CircularProgress disableShrink />

            <Typography variant="overline" sx={{ color: 'primary.main', marginTop: 1 }}>
                { children || t('common.text.loading') }
            </Typography>
        </StyledContainer>
    );
};

LoadingPlaceholder.propTypes = {
    children: PropTypes.func,
    height: PropTypes.any
};

export default LoadingPlaceholder;
